<!-- Error page-->
<div class="misc-wrapper">
  <a class="brand-logo" href="javascript:void(0);">
    <img src="{{ coreConfig.app.appLogoImage }}" alt="brand-logo" height="28" />
  </a>
  <div class="misc-inner p-2 p-sm-3">
    <div class="w-100 text-center">
      <h2 class="mb-1">{{'MISC.PAGE_NOT_FOUND' | translate}}🕵🏻‍♀️</h2>
      <p class="mb-2">Oops! 😖 {{'MISC.MISC_PAGE_REMOVED'  | translate}}</p>
      <a class="btn btn-primary mb-2 btn-sm-block" href="/" rippleEffect>{{'MISC.BACK_TO_HOME'  | translate}}</a>
      <img class="img-fluid" alt="Error page"
           [src]="coreConfig.layout?.skin === 'dark' ? 'assets/images/pages/error-dark.svg' : 'assets/images/pages/error.svg'" />
    </div>
  </div>
</div>
<!-- / Error page-->
